import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBusinessCard, IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BusinessCardService {
  constructor(private http: HttpClient) {}

  getAllBusinessCard(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/business-card', { params });
  }

  getBusinessCardById(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/business-card/${id}`);
  }

  deleteBusinessCard(id: string) {
    return this.http.delete<ApiResponse>(`/v1/admin/business-card/${id}`);
  }

  getBusinessCardByUser(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/business-card/user/${id}`);
  }

  updateBusinessCard(id: string, business: IBusinessCard): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`v1/admin/business-card/${id}`, business);
  }
  exportBusinessCardContent(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/business-card/export`, filterData, options);
  }

  viewBusinessCard(id: string) {
    return this.http.get<ApiResponse>(`/v1/business-card/view/${id}/`);
  }

  getOriginalUrl(nanoid: string) {
    return this.http.get<ApiResponse>(`/v1/business-card/original-url/${nanoid}/`);
  }
}
